import React from 'react';
import ColumnChart from '../ColumnChart';
import LineChart from '../LineChart';

interface IProps {
  daysValues: Array<number>;
  previousDaysValues?: Array<number>;
  options?: any;
  chartType?: 'bar' | 'line' | 'area';
}

const DAYS = ['Sun', 'Mon', 'Tue', 'Web', 'Thu', 'Fri', 'Sat'];

const WeekDaysChart: React.FC<IProps> = React.memo(
  ({ daysValues, previousDaysValues, options, chartType = 'bar' }) => {
    const data = DAYS.map((day, index) => ({
      x: day,
      y: daysValues[index] || 0,
    }));
    let previousData;
    if (previousDaysValues) {
      previousData = DAYS.map((day, index) => ({
        x: day,
        y: previousDaysValues[index] || 0,
      }));
    }
    if (chartType === 'bar') {
      return <ColumnChart data={data} previousData={previousData} options={options} />;
    }
    return (
      <LineChart data={data} previousData={previousData} options={options} chartType={chartType} />
    );
  }
);

WeekDaysChart.displayName = 'WeekDaysChart';

export default WeekDaysChart;
